import type { Ref } from 'react';
import { Link } from 'react-router-dom';
import { ButtonLink as LiquidityButtonLink, type ButtonLinkProps as LiquidityButtonLinkProps } from '@c2fo/liquidity';

interface ButtonLinkProps extends Omit<LiquidityButtonLinkProps<typeof Link>, 'as' | 'ref'> {
  to: string;
  ref?: Ref<HTMLAnchorElement>;
}

export function ButtonLink({ ref, ...props }: ButtonLinkProps) {
  return <LiquidityButtonLink {...props} ref={ref} as={Link} />;
}
